var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"box black rounded",attrs:{"id":"gallery-box"}},[_c('ResponsiveImageSlider',{attrs:{"id":"gallery","label":_vm.asText(_vm.data.gallery_title),"slides":_vm.data.gallery}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }